
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import TopNavbar from '../Navbar/TopNavbar';
import SecondNav from '../Navbar/SecondNav';
import Footer from './Footer';
import ChatPopup from './ChatPopup';

const services = [
  {
    title: 'Ceramic Coating',
    description:
      'High-gloss, hydrophobic protection that resists scratches, UV rays, and chemicals.',
    details: [
      'Durable nano-ceramic layer',
      'Enhances paint gloss and depth',
      'Repels water, dirt, and contaminants',
      'Reduces swirl marks and scratches',
    ],
    image:
      'https://media.istockphoto.com/id/1276960885/photo/car-service-worker-applying-nano-coating-on-a-car-detail.jpg?s=612x612&w=0&k=20&c=uG2gei5RiQf5biOUegOLjzOiZFUdznwcxfNwTaL7h0Y=',
  },
  {
    title: 'Paint Protection Film (PPF)',
    description:
      'Self-healing TPU film that guards against chips, swirls, and minor abrasions.',
    details: [
      'Self-healing technology for minor scratches',
      'Protects against stone chips and road debris',
      'Maintains factory finish and gloss',
      'Virtually invisible once applied',
    ],
    image:
      'https://media.istockphoto.com/id/1313133422/photo/installation-of-a-protective-paint-and-varnish-transparent-film-on-the-car-ppf-polyurethane.jpg?s=612x612&w=0&k=20&c=S_APhWj9IHpFOlBbrzOLjONyCFURu8cRn7TOr-uTxlc=',
  },
  {
    title: 'Interior Coating',
    description:
      'Advanced coating for leather, fabric, and plastics to repel stains and dirt.',
    details: [
      'Protects upholstery from spills and stains',
      'Repels dust and dirt for easy cleaning',
      'Maintains natural texture and appearance',
      'Increases longevity of interior surfaces',
    ],
    image:
      'https://media.istockphoto.com/id/2096432758/photo/cleaning-the-car-interior-with-a-brush-a-car-detailing-worker-cleaning-the-interior-of-a-car.jpg?s=612x612&w=0&k=20&c=2N91bv5B6YLkAw7YXrJ_NwHJnaUVLQkUfWBYimvoWhY=',
  },
  
];

function Services() {
  return (
    <Box sx={{ backgroundColor: '#fff', minHeight: '100vh' }}>
      <TopNavbar />
      <SecondNav />

      <Box sx={{ py: 8, backgroundColor: '#f5f5f5', mt: 4 }}>
        <Container maxWidth="lg">
        <Typography
            variant="h3"
            sx={{
              fontWeight: 'bold',
              color: '#007BFF',
              textAlign: 'center',
              mb: 3,
              fontFamily: 'Arial, sans-serif',
            }}
          >
            SERVICES
          </Typography> 

          <Typography
  variant="h6"
  sx={{
    textAlign: 'center',
    maxWidth: '800px',
    mx: 'auto',
    mb: 6,
    mt: 6,
    color: '#007BFF', // Bootstrap blue or choose your custom
    fontSize: { xs: '2.9rem', md: '1.8rem' }, // Responsive font size
    fontWeight: 700,
  }}
>
  Comprehensive Protection Solutions for Every Surface
</Typography>


          {/* MAIN SERVICES LIST */}
          <Box>
            {services.map((service, index) => (
              <Grid
                container
                spacing={4}
                key={index}
                alignItems="center"
                sx={{ mb: 6 }}
                direction={{ xs: 'column', md: index % 2 === 0 ? 'row' : 'row-reverse' }}
              >
                {/* IMAGE */}
                <Grid item xs={12} md={6}>
                  <Box
                    component="img"
                    src={service.image}
                    alt={service.title}
                    sx={{
                      width: '100%',
                      height: 300,
                      objectFit: 'cover',
                      borderRadius: 4,
                      boxShadow: '0 10px 20px rgba(0,0,0,0.15)',
                    }}
                  />
                </Grid>

                {/* CONTENT */}
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      backgroundColor: '#000',
                      color: '#fff',
                      border: '1px solid #2E9FFF',
                      borderRadius: 4,
                      padding: 4,
                      boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{ color: '#2E9FFF', fontWeight: 700, mb: 2 }}
                    >
                      {service.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#ccc', mb: 2 }}>
                      {service.description}
                    </Typography>

                    <List dense sx={{ mb: 3 }}>
                      {service.details.map((detail, idx) => (
                        <ListItem key={idx} sx={{ py: 0, color: '#a9c9ff' }}>
                          <ListItemText primary={`• ${detail}`} />
                        </ListItem>
                      ))}
                    </List>

                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: '#2E9FFF',
                        color: '#fff',
                        fontWeight: '600',
                        borderRadius: 2,
                        padding: '10px 20px',
                        alignSelf: 'flex-start',
                        '&:hover': { backgroundColor: '#005B99' },
                      }}
                    >
                      Learn More
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Container>
        <ChatPopup/>
      </Box>
      <Footer/>
    </Box>
  );
}

export default Services;












